import { render, staticRenderFns } from "./NewBaseTable.vue?vue&type=template&id=30c789b5"
import script from "./NewBaseTable.vue?vue&type=script&lang=js"
export * from "./NewBaseTable.vue?vue&type=script&lang=js"
import style0 from "./NewBaseTable.vue?vue&type=style&index=0&id=30c789b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports